<template>
	<div>
		<el-input v-model="row[column.key]" placeholder="请输入"></el-input>
	</div>
</template>

<script>
import mixin from '@/components/tableCells/mixin';

export default {
	name: 'inputCell',
	mixins: [mixin],
};
</script>

<style scoped></style>
